//backend request simulation
import Img from '../../assets/img/blog/01.png';

export const data = [
  {
    title: 'the most used languages in 2021',
    thumbnail: Img
  },
  {
    title: 'the most used languages in 2021',
    thumbnail: Img
  },
  {
    title: 'the most used languages in 2021',
    thumbnail: Img
  },
  {
    title: 'the most used languages in 2021',
    thumbnail: Img
  },
  {
    title: 'the most used languages in 2021',
    thumbnail: Img
  },
  {
    title: 'the most used languages in 2021',
    thumbnail: Img
  },
];